import { PurchaseOrder } from "../../../../../models/purchase.order";
import {
  Translate,
  ValidateCSVError,
  ValidateCSVFieldErrors,
  addErrorInLine,
  messages,
} from "../../../UploadCSVFile/types";
import { CartonReceiveTemplateCSV, getCartonReceiveTemplateColumnName } from "../../util";

export interface ValidateCSVFileExtraCheck {
  label: keyof PurchaseOrder;
  value: number | string;
}

export const validateCSVField = (
  dataItem: CartonReceiveTemplateCSV,
  line: number,
  lineErrors: ValidateCSVFieldErrors,
  translate: Translate
) => {
  const cartonTemplateColumnName = getCartonReceiveTemplateColumnName(translate);

  let dataItemValid = true;

  const addError = (messageError: ValidateCSVError) => {
    addErrorInLine(lineErrors, line, translate(messageError), () => {
      dataItemValid = false;
    });
  };

  const message = messages(translate);

  if (!dataItem.sscc) addError(message.filled(cartonTemplateColumnName.sscc));

  return dataItemValid;
};

export const validateCSVFields = (
  data: CartonReceiveTemplateCSV[],
  lineErrors: ValidateCSVFieldErrors,
  translate: Translate
) => {
  const valids = new Array(data.length).fill(true, 0);

  data.forEach((dataItem, index) => {
    const line = index + 2;

    valids[index] = validateCSVField(dataItem, line, lineErrors, translate);
  });

  return {
    valid: valids.every((valid) => valid),
  };
};
